import { useTranslation } from 'react-i18next';

import { getLocale } from '@actual-app/core/shared/locale';

import { useGlobalPref } from './useGlobalPref';

/**
 * Idioma de fechas y meses: el que usa la app para los textos (castellano o
 * catalán), para que no salgan meses en inglés con el móvil en inglés.
 */
export function useLanguage() {
  const [language] = useGlobalPref('language');
  const { i18n } = useTranslation();
  return i18n.language || language || navigator.language || 'en-US';
}

export function useLocale() {
  return getLocale(useLanguage());
}
